import { OnInit, Renderer, ElementRef, EventEmitter } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { Observable } from 'rxjs';
var CsTimepickerComponent = /** @class */ (function () {
    function CsTimepickerComponent(el_ref, renderer, settings) {
        this.el_ref = el_ref;
        this.renderer = renderer;
        this.settings = settings;
        this._onTouched = function () { };
        this._onChange = function () { };
        this.hourEvent = new EventEmitter();
        this.minuteEvent = new EventEmitter();
        this.minutesDuration = 15;
        this.valueEmitter = new EventEmitter();
        // Timepicker functions
        this.hoursDropdownItems = [];
        this.minutesDropdownItems = this.generateMinuteArray(this.minutesDuration);
        this.second = 0;
        this._showMeridian = true;
    }
    // Set Touched on blur
    CsTimepickerComponent.prototype.onBlur = function () {
        this._onTouched();
    };
    // From ControlValueAccessor Interface
    CsTimepickerComponent.prototype.writeValue = function (value) {
        var _this = this;
        if (value !== this._value) {
            if (value instanceof Date)
                this._value = value;
            else if (typeof (value) == 'string') {
                this._value = new Date(value);
                setTimeout(function () { return _this.updateModelValue(); }, 10);
            }
            else {
                this._value = new Date();
                setTimeout(function () { return _this.updateModelValue(); }, 10);
            }
            this.assignValues();
        }
    };
    // From ControlValueAccessor Interface
    CsTimepickerComponent.prototype.registerOnChange = function (fn) {
        this._onChange = fn;
    };
    // From ControlValueAccessor Interface
    CsTimepickerComponent.prototype.registerOnTouched = function (fn) {
        this._onTouched = fn;
    };
    // Publish updated value to form control
    CsTimepickerComponent.prototype.updateModelValue = function () {
        this._onChange(this._value);
        this.emitValue(this._value);
    };
    Object.defineProperty(CsTimepickerComponent.prototype, "showMeridian", {
        set: function (val) {
            var _this = this;
            this._showMeridian = !!val;
            // 01-12 with meridian (00:xx is shown as 12 AM), 00-23 without
            this.hoursDropdownItems = this._showMeridian
                ? (new Array(12)).join('#').split('#').map(function (h, index) { return _this.pad(index + 1); })
                : (new Array(24)).join('#').split('#').map(function (h, index) { return _this.pad(index); });
        },
        enumerable: true,
        configurable: true
    });
    CsTimepickerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._value = new Date();
        var intlSettings = this.settings.getIntlSettings();
        this._showMeridian = parseInt(intlSettings['time']) === 0;
        if (this.timepickerChangeEvent) {
            this.eventsSubscription = this.timepickerChangeEvent.subscribe(function (data) {
                if (data) {
                    if (data.hasOwnProperty('hour')) {
                        _this.hour = data.hour;
                        _this.onHourChange();
                    }
                    else if (data.hasOwnProperty('min')) {
                        _this.minute = data.min;
                        _this.onMinuteChange();
                    }
                }
            });
        }
        this.showMeridian = this._showMeridian;
        this.minutesDropdownItems = this.generateMinuteArray(this.minutesDuration);
    };
    // Assigning values to the component variables
    CsTimepickerComponent.prototype.assignValues = function () {
        if (this._showMeridian) {
            this.meridian = this._value.getHours() >= 12 ? 'PM' : 'AM';
            // 00:xx is shown as 12:xx AM, 12:xx as 12:xx PM
            this.hour = this.pad(this._value.getHours() % 12 === 0 ? 12 : this._value.getHours() % 12);
        }
        else {
            this.hour = this.pad(this._value.getHours());
        }
        this.minute = this.pad(this._value.getMinutes());
    };
    // Add leading zero
    CsTimepickerComponent.prototype.pad = function (n) {
        return ("00" + n).slice(-2);
    };
    CsTimepickerComponent.prototype.generateMinuteArray = function (duration) {
        var result = [];
        for (var i = 0; i < 60; i += duration) {
            result.push(i < 10 ? "0" + i : "" + i);
        }
        return result;
    };
    CsTimepickerComponent.prototype.onHourChange = function () {
        this._value.setHours(this.getHoursIn24());
        this._onTouched();
        this.updateModelValue();
        this.hourEvent.emit((this._showMeridian && this.meridian === 'PM' ? parseInt(this.hour) + 12 : parseInt(this.hour)).toString());
    };
    CsTimepickerComponent.prototype.onMinuteChange = function () {
        this._value.setMinutes(parseInt(this.minute));
        this._onTouched();
        this.updateModelValue();
        this.minuteEvent.emit(this.minute);
    };
    CsTimepickerComponent.prototype.onMeridianChange = function () {
        this._value.setHours(this.getHoursIn24());
        this._onTouched();
        this.updateModelValue();
        this.hourEvent.emit((this._showMeridian && this.meridian === 'PM' ? parseInt(this.hour) + 12 : parseInt(this.hour)).toString());
        this.minuteEvent.emit(this.minute);
    };
    // Selected hour converted to 0-23. Never returns 24, as setHours(24) rolls the date over to the next day
    CsTimepickerComponent.prototype.getHoursIn24 = function () {
        var hours = parseInt(this.hour);
        if (this._showMeridian) {
            hours = hours % 12;
            if (this.meridian === 'PM')
                hours += 12;
        }
        return hours;
    };
    CsTimepickerComponent.prototype.emitValue = function (value) {
        this.valueEmitter.emit(value);
    };
    return CsTimepickerComponent;
}());
export { CsTimepickerComponent };
